import { $ } from "@/common/Axios";

export default {
  /**
   * 学生直播学习记录
   */
  studentLiveCourseSchedule_watchLive: {
    /*
     * 观看直播
     * liveCourseScheduleId 直播课表id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/sms/study/studentLiveCourseSchedule/watchLive", p, c),
  },
  studentLiveCourseSchedule_updatePlaybackProgress: {
    /*
     * 修改回看进度，切换视频，返回，播放结束，暂停，HOME等情况调用
     * liveCourseScheduleId 直播课表id (integer query required)
     * progress 进度 (integer query required)
     * duration 回放时长 (integer query required)
     */
    put: (p, c) =>
      $.put(
        "/api/sms/study/studentLiveCourseSchedule/updatePlaybackProgress",
        p,
        c
      ),
  },
  studentLiveCourseSchedule_listByStudent: {
    /*
     * 学生直播观看情况
     * userId 用户id (integer query required)
     * level 直播课层次 (string query required)
     * course 直播课名字 (string query required)
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentLiveCourseSchedule/listByStudent", p, c),
  },
  studentLiveCourseSchedule_exportStudentAdultExamLive: {
    /*
     * 成考学生直播观看情况导出
     * adultExamYear 成考年度 (string query required)
     * timeType 直播开始时间类型 (string query )
     * start 直播开始时间：开始 (string query )
     * end 直播开始时间：结束 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/sms/study/studentLiveCourseSchedule/exportStudentAdultExamLive",
        p,
        c
      ),
  },

  /**
   * 学生知识点
   */
  studentKnowledge_progress: {
    /*
     * 修改进度，切换视频（新老视频都调用），返回，播放结束，暂停，HOME等情况调用，学习1分钟
     * knowledgeId 知识点id (integer query required)
     * progress 进度 (integer query required)
     * study 0进度1学习 (integer query required)
     */
    put: (p, c) => $.put("/api/sms/study/studentKnowledge/progress", p, c),
  },
  studentKnowledge_searchRecordById: {
    /*
     * 根据studentKnowledgeId查询观看记录区间
     * studentKnowledgeId studentKnowledgeId (integer query required)
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentKnowledge/searchRecordById", p, c),
  },
  studentKnowledge_listSkillTranVideo: {
    /*
     * 视频观看列表-技能培训
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentKnowledge/listSkillTranVideo", p, c),
  },
  studentKnowledge_listAdultExamQualityForClient: {
    /*
     * 最近学习的精品课章节
     */
    get: (p, c) =>
      $.get(
        "/api/sms/study/studentKnowledge/listAdultExamQualityForClient",
        p,
        c
      ),
  },
  studentKnowledge_latestCourseId: {
    /*
     * 最近学习的课程id
     * courseType 课程类型：成考，成教 (string query required)
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentKnowledge/latestCourseId", p, c),
  },
  studentKnowledge_exportSkillTranVideo: {
    /*
     * 视频观看导出-技能培训
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentKnowledge/exportSkillTranVideo", p, c),
  },

  /**
   * 学生刷题
   */
  studentExercise_read: {
    /*
     * 阅卷
     * id 学生试卷id (integer query required)
     * studentSubjectIds 学生答题id (array query required)
     * scores 分数 (array query required)
     */
    put: (p, c) => $.put("/api/sms/study/studentExercise/read", p, c),
  },
  studentExercise_handSubject: {
    /*
     * 交卷(返回练习id)
     * type 类型：历年真题，模拟测试，章节练习，顺序练习 (string query required)
     * latestExerciseId 只有当继续练习的时候，把这个传给我 (integer query )
     * exerciseTime 练习时间（秒） (integer query required)
     * belongId 试卷或知识点id或直播课章节id (integer query required)
     * subjectIds 题目id (array query required)
     * answers 答案 (array query required)
     */
    post: (p, c) => $.post("/api/sms/study/studentExercise/handSubject", p, c),
  },
  studentExercise_listSkillTrainMockExercise: {
    /*
     * 模拟测试记录列表-技能培训
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentExercise/listSkillTrainMockExercise", p, c),
  },
  studentExercise_listSkillTrainChapterExercise: {
    /*
     * 章节练习列表-技能培训
     */
    get: (p, c) =>
      $.get(
        "/api/sms/study/studentExercise/listSkillTrainChapterExercise",
        p,
        c
      ),
  },
  studentExercise_listLatestStudentExerciseForClient: {
    /*
     * 学习记录
     * type 类型: 历年真题,模拟测试、顺序练习、顺序练习-组卷 (string query required)
     * courseId 课程id (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/sms/study/studentExercise/listLatestStudentExerciseForClient",
        p,
        c
      ),
  },
  studentExercise_listAdultExamAssessmentStudentExercise: {
    /*
     * 成考摸底考试阅卷列表
     */
    get: (p, c) =>
      $.get(
        "/api/sms/study/studentExercise/listAdultExamAssessmentStudentExercise",
        p,
        c
      ),
  },
  studentExercise_exportSkillTrainMockExercise: {
    /*
     * 模拟测试导出列表-技能培训
     */
    get: (p, c) =>
      $.get(
        "/api/sms/study/studentExercise/exportSkillTrainMockExercise",
        p,
        c
      ),
  },
  studentExercise_exportSkillTrainChapterExercise: {
    /*
     * 章节练习导出-技能培训
     */
    get: (p, c) =>
      $.get(
        "/api/sms/study/studentExercise/exportSkillTrainChapterExercise",
        p,
        c
      ),
  },
  studentExercise_detailForClient: {
    /*
     * 答题记录详情
     * id 答题记录id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentExercise/detailForClient", p, c),
  },

  /**
   * 错题集
   */
  studentWrongSubject_addForSelf: {
    /*
     * 增加自考错题（每日一练）
     * subjectIds 习题id (array query required)
     * answers 答案 (array query required)
     */
    post: (p, c) =>
      $.post("/api/sms/study/studentWrongSubject/addForSelf", p, c),
  },
  studentWrongSubject_listSubjectForSelf: {
    /*
     * 自考错题集列表（习题）
     * knowledgeId 知识点id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentWrongSubject/listSubjectForSelf", p, c),
  },
  studentWrongSubject_listKnowledgeForSelf: {
    /*
     * 自考错题集列表（知识点）
     * courseId 课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentWrongSubject/listKnowledgeForSelf", p, c),
  },
  studentWrongSubject_listCollectSubject: {
    /*
     * 错题集习题列表
     * belongId 归属id (integer query required)
     * type 类型:历年真题,模拟测试,顺序练习 (string query required)
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentWrongSubject/listCollectSubject", p, c),
  },
  studentWrongSubject_listCollectPaper: {
    /*
     * 错题集试卷列表
     * courseId 课程id (integer query required)
     * type 类型:历年真题,模拟测试,顺序练习，顺序练习-组卷 (string query required)
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentWrongSubject/listCollectPaper", p, c),
  },
  studentWrongSubject: {
    /*
     * 移除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/sms/study/studentWrongSubject", p, c),
  },
  studentWrongSubject_removeByBelongId: {
    /*
     * 移除
     * belongId 归属id (integer query required)
     * type 类型:章节练习,历年真题,模拟测试,直播课课后练习 (string query required)
     */
    delete: (p, c) =>
      $.delete("/api/sms/study/studentWrongSubject/removeByBelongId", p, c),
  },

  /**
   * 学生答题记录
   */
  studentSubject_handSubject: {
    /*
     * 交卷(返回练习id)
     * type 类型：历年真题，模拟测试，摸底考试，章节练习，顺序练习 (string query required)
     * latestExerciseId 只有当继续练习的时候，把这个传给我 (integer query )
     * exerciseTime 练习时间（秒） (integer query required)
     * belongId 试卷或知识点id或直播课章节id (integer query required)
     * subjectIds 题目id (array query required)
     * answers 答案 (array query required)
     */
    post: (p, c) => $.post("/api/sms/study/studentSubject/handSubject", p, c),
  },
  studentSubject_studentSubjectCount: {
    /*
     * 个人刷题数量
     * courseId 课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentSubject/studentSubjectCount", p, c),
  },
  studentSubject_studentStudyReport: {
    /*
     * 学习报告
     */
    get: (p, c) =>
      $.get("/api/sms/study/studentSubject/studentStudyReport", p, c),
  },
  studentSubject_studentScore: {
    /*
     * 个人分数
     * courseId 课程id (integer query required)
     */
    get: (p, c) => $.get("/api/sms/study/studentSubject/studentScore", p, c),
  },

  /**
   * 加入
   */
  join_join: {
    /*
     * 加入（免费加入）
     * join  ( query required)
     */
    post: (p, c) => $.post("/api/sms/study/join/join", p, c),
  },
  join_batchJoinOnlineCourse: {
    /*
     * 批量加入(会删掉之前加入的)
     * courseType 课程类型：成教，成考，专升本 (string query required)
     * contentIds 课程id (array query required)
     */
    post: (p, c) => $.post("/api/sms/study/join/batchJoinOnlineCourse", p, c),
  },
  join_listStudentOnlineCourseForClient: {
    /*
     * 加入的线上课程列表
     * courseType 课程类型：成教，成考，专升本 (string query required)
     */
    get: (p, c) =>
      $.get("/api/sms/study/join/listStudentOnlineCourseForClient", p, c),
  },
  join: {
    /*
     * 取消加入
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/sms/study/join", p, c),
  },

  /**
   * 评价
   */
  discuss_discuss: {
    /*
     * 评价
     * discuss  ( query required)
     */
    post: (p, c) => $.post("/api/sms/study/discuss/discuss", p, c),
  },
  discuss_listForClient: {
    /*
     * 评价列表
     * type 评价内容:线上课程，直播课程 (string query required)
     * contentId 评价内容id (integer query required)
     */
    get: (p, c) => $.get("/api/sms/study/discuss/listForClient", p, c),
  },
  discuss_listForCkOnline: {
    /*
     * 成考线上课程评价列表
     */
    get: (p, c) => $.get("/api/sms/study/discuss/listForCkOnline", p, c),
  },
  discuss: {
    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/sms/study/discuss", p, c),
  },

  /**
   * 收藏
   */
  collect: {
    /*
     * 收藏|取消收藏
     * type 类型：知识点，习题 (string query required)
     * contentId 内容id (integer query required)
     */
    post: (p, c) => $.post("/api/sms/study/collect", p, c),
  },
  collect_listSubjectForSelf: {
    /*
     * 自考习题收藏列表（习题）
     * knowledgeId 知识点id (integer query required)
     */
    get: (p, c) => $.get("/api/sms/study/collect/listSubjectForSelf", p, c),
  },
  collect_listKnowledgeForSelf: {
    /*
     * 自考习题题收藏列表（知识点）
     * courseId 课程id (integer query required)
     */
    get: (p, c) => $.get("/api/sms/study/collect/listKnowledgeForSelf", p, c),
  },
  collect_listCollectSubject: {
    /*
     * 习题收藏列表
     * belongId 归属id (integer query required)
     * type 类型:直播课课后练习,章节练习,历年真题,模拟测试 (string query required)
     */
    get: (p, c) => $.get("/api/sms/study/collect/listCollectSubject", p, c),
  },
  collect_listCollectPaper: {
    /*
     * 试卷收藏列表
     * courseId 课程id (integer query required)
     * type 类型: 历年真题,模拟测试、顺序练习、顺序练习-组卷 (string query required)
     */
    get: (p, c) => $.get("/api/sms/study/collect/listCollectPaper", p, c),
  },
  collect_listCollectKnowledge: {
    /*
     * 知识点收藏列表
     * courseId 课程id (integer query required)
     */
    get: (p, c) => $.get("/api/sms/study/collect/listCollectKnowledge", p, c),
  },
  collect_listCollectCourseSubject: {
    /*
     * 课程(习题)收藏列表
     * courseType 课程类型:成教，成考，专升本 (string query required)
     */
    get: (p, c) =>
      $.get("/api/sms/study/collect/listCollectCourseSubject", p, c),
  },
  collect_listCollectCourseKnowledge: {
    /*
     * 课程(知识点)收藏列表
     * courseType 课程类型:成教，成考，专升本 (string query required)
     */
    get: (p, c) =>
      $.get("/api/sms/study/collect/listCollectCourseKnowledge", p, c),
  },
};
